export default __webpack_public_path__ + "static/media/dark11.62446c88.png";